
import Vue from 'vue';
import i18n from '@/i18n';
import store from '@/store';
import UserService from '@/features/user/UserService';
import DialogService from '@/plugins/dialog/DialogService';

/**
 * TODO Este evento é responsável por verificar o controle de autorização
 * na transição de páginas
 * @param {*} to
 * @param {*} from
 * @param {*} next
 */
const beforeEach = async (to, from, next) => {
  let response = null;
  if (to.name !== 'login' && to.name !== 'resetPassword') {
    response = await UserService.request('GET', 'authenticate/check');
  }
  if (response && response.data.status !== 'valid') {
    store.dispatch('logout');
    DialogService.close();
    Vue.$toast.error(i18n.t('messages.login.logoutInactive'));
    next({ name: 'login' });
  } else if (store.state.currentUser && to.meta.requireRoles
    && !UserService.hasProfile(store.state.currentUser, to.meta.requireRoles)) {
    next({ name: 'not-authorized' });
  } else {
    next();
  }
};

export default beforeEach;



// WEBPACK FOOTER //
// ./src/router/guards/AuthorizationGuard.js